import React, { FC } from 'react';
import { FontWeights } from 'core/CssVariables';
import { Text } from 'components/Base/Typography';
import NotificationItem from 'components/Base/Layout/Notifications/components/NotificationItem';
import { TConvertedToPetAcknowledgmentUI } from 'data/types/animal.types';
import { getSpeciesDisplayInfo } from 'helpers/utils';
import SpeciesInfoIcon from 'components/Shared/SpeciesInfoIcon';
import NotificationActions from './NotificationActions';
import NotificationInfo from './NotificationInfo';

type TConvertedToPetNotificationProps = {
  data: TConvertedToPetAcknowledgmentUI[];
  borderedNotificationItems: string[];
};

const ConvertedToPetNotification: FC<TConvertedToPetNotificationProps> = ({
  data,
  borderedNotificationItems,
}) => {
  if (data.length === 0) return null;
  return (
    <>
      {data.map(animal => (
        <NotificationItem
          hasTopBorder={borderedNotificationItems.includes(animal.id)}
          key={animal.id}
          textSection={
            <>
              <Text fontWeight={FontWeights.SemiBold}>
                {animal.name} (
                {
                  getSpeciesDisplayInfo({
                    id: animal.speciesPredefinedId || '',
                    value: animal.species || '',
                  }).displayText
                }
                {getSpeciesDisplayInfo({
                  id: animal.speciesPredefinedId || '',
                  value: animal.species || '',
                }).showInfoIcon && (
                  <>
                    {' '}
                    <SpeciesInfoIcon
                      species={{
                        id: animal.speciesPredefinedId || '',
                        value: animal.species || '',
                      }}
                    />
                  </>
                )}
                ) has been converted to PET{' '}
              </Text>
              <NotificationInfo animal={animal} />
            </>
          }
          actionSection={<NotificationActions animal={animal} />}
        />
      ))}
    </>
  );
};

export default ConvertedToPetNotification;
